var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { isUserDetails } from '@/components/user-details/helpers/is-user-details.helper';
import { getAttributtionFromStore } from '@/helpers/get-attribution-from-store.helper';
import { globalLeadSource } from 'hx-analytics/src/functions/url-lead-source/get-url-lead-source.helper';
export function getSalesforceLeadPayload(_a) {
    var _b;
    var widget = _a.widget, dinTest = _a.dinTest, wizard = _a.wizard;
    if (!isUserDetails(widget.userDetails))
        return;
    var userDetails = widget.userDetails;
    var test = __assign({ first_name: userDetails['first-name'], last_name: userDetails['last-name'], birth_year: userDetails['birth-year'], email: userDetails['email'], contact_number: "+1".concat(userDetails['contact-number']), snr_result: Number(dinTest.result.averageSnr), hearing_category: dinTest.result.category, user_selected_volume: Number(wizard.form.volume), source: globalLeadSource ||
            "".concat(process.env.REACT_APP_SALESFORCE_LEADS_SOURCE_PREFIX), consent: userDetails['consent'], newsletter_consent: userDetails['newsletter-consent'], health_member_discounts: userDetails['health-and-member-discounts'], feedback: (userDetails === null || userDetails === void 0 ? void 0 : userDetails.feedback) || '', do_you_think_you_have_hearing_loss: (_b = wizard.form) === null || _b === void 0 ? void 0 : _b['hearing-loss'] }, getAttributtionFromStore(widget.hostDetails));
    return test;
}
